import React, { useMemo, useState } from 'react';
import styles from './CardRep.module.scss';
import { useStartLearningPathMutation } from '../../LearningPaths.queries';
import { useLearningPathsStore } from '../../LearningPaths.store';
import FocusCardRepComponent from '../FocusCardRep/FocusCardRepComponent';
const FocusCardRep = ({ data = {}, isLoading = false, completed = 1, hasInProgress = true, setInProgress = null, isInProgress = false }) => {
  const canBeClicked = useMemo(() => completed === 0 && !hasInProgress, [completed, hasInProgress]);
  const { mutate } = useStartLearningPathMutation();
  const { setSelectedRepLearningPathID } = useLearningPathsStore();
  const [clicked, setClicked] = useState(false);
  const learningPath = useMemo(() => {
    return data?.learning_path;
  }, [data]);
  if (isLoading) return null;

  const handleClick = () => {
    const uuid = data?.learning_path?.uuid;
    if (completed === 1) {
      setSelectedRepLearningPathID(uuid);
      return;
    }
    if (!canBeClicked || clicked) return;
    setClicked(true);
  };

  return (
    <div className={styles.container}>
      <FocusCardRepComponent learningPath={learningPath} completed={completed} setInProgress={setInProgress} isInProgress={isInProgress} />
    </div>
  );
};

export default FocusCardRep;
